export default __webpack_public_path__ + "static/media/closed.2e55dbfc.svg";